<template>
  <!-- 身份验证框 -->
  <el-dialog
    :title="$t('showDialogs.authentication')"
    :close-on-click-modal="false"
    :visible.sync="showDialog"
    width="600px"
  >
    <el-form
      ref="form"
      :model="form"
      :label-position="'top'"
      :size="'medium'"
      @submit.native.prevent
      label-width="90px"
    >
      <!--谷歌验证码-->
      <el-form-item :label="$t('showDialogs.gauth')" v-if="authType==='otp'">
        <el-input v-model="param" size="large" autofocus :placeholder="$t('showDialogs.pgauth')"></el-input>
      </el-form-item>
      <!--短信验证码-->
      <el-form-item :label="$t('showDialogs.mauth')" v-else-if="authType==='mobile'">
        <p v-if="verify">{{verify}}</p>
        <el-input :placeholder="$t('showDialogs.pmauth')" size="large" v-model="param">
          <template slot="append">
            <el-button @click="getCode" autofocus v-if="!codeTime">{{$t('bmobile.gcode')}}</el-button>
            <span v-if="codeTime">{{codeTime}}{{$t('bmobile.again')}}</span>
          </template>
        </el-input>
      </el-form-item>
      <!--邮箱验证码-->
      <el-form-item :label="$t('showDialogs.eauth')" v-else-if="authType==='email'">
        <p v-if="verify">{{verify}}</p>
        <el-input :placeholder="$t('showDialogs.peauth')" size="large" v-model="param">
          <template slot="append">
            <el-button @click="getCode" autofocus v-if="!codeTime">{{$t('bmobile.gcode')}}</el-button>
            <span v-if="codeTime">{{codeTime}}{{$t('bmobile.again')}}</span>
          </template>
        </el-input>
      </el-form-item>
      <!--密码-->
      <el-form-item :label="$t('showDialogs.password')" v-else-if="authType==='password'">
        <el-input
          v-model="param"
          type="password"
          autofocus
          show-password
          size="large"
          :placeholder="$t('showDialogs.ppass')"
        ></el-input>
      </el-form-item>
      <!-- 资金密码 -->
       <el-form-item :label="$t('security.payPassword')" v-else-if="authType==='payPassword'">
        <el-input
          v-model="param"
          type="password"
          autofocus
          show-password
          size="large"
          :placeholder="$t('security.payPassword')"
        ></el-input>
      </el-form-item>
      <!--通用验证码-->
      <el-form-item :label="$t('showDialogs.code')" v-else>
        <p v-if="verify">{{verify}}</p>
        <el-input :placeholder="$t('showDialogs.pcode')" size="large" v-model="param">
          <template slot="append">
            <el-button @click="getCode" autofocus v-if="!codeTime">{{$t('bmobile.gcode')}}</el-button>
            <span v-if="codeTime">{{codeTime}}{{$t('bmobile.again')}}</span>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        :loading="disabled"
        :disabled="!param"
        @click="sure"
      >{{$t('main.confirm')}}</el-button>
      <el-button @click="cancel">{{$t('main.cancel')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import baseApi from "@/api/base";

export default {
  props: ["code"],
  data() {
    return {
      password: "",
      otp: "",
      codeTime: 0,
      callback: "",
      cancelCall: "",
      showDialog: false,
      param: "",
      disabled: false,
      parent: null,
      authType: {},
      verify: "",
      form: {},
      data: {},
      typeName: ""
    };
  },
  mounted() {},
  methods: {
    init(parent) {
      this.disabled = false;
      this.param = "";
      this.parent = parent;
    },
    show(datas) {
      this.$nextTick(() => {
        this.authType = datas.authType;
        this.verify = datas.verify;
        this.showDialog = true;
      });
      this.callback = datas.callback;
      this.data = datas.data;
      this.typeName = datas.typeName;
      this.cancelCall = datas.cancel;
    },
    endTime() {
      this.codeTime = 59;
      this.timers = setInterval(() => {
        if (this.codeTime > 0 && this.codeTime < 60) {
          this.codeTime--;
        } else {
          clearInterval(this.timers);
        }
      }, 1000);
    },
    async getCode() {
      this.endTime();
      try {
        let result = await baseApi.getAccountCode();
        this.$message.success(this.$t("CODE_HAS_SEND"));
      } catch (e) {}
    },
    sure() {
      if (this.param) {
        this.disabled = true;
        this.$emit("code", this.param,this.authType);

        if (this.typeName) {
          this.callback && this.callback(this.typeName);
        } else if (this.data) {
          this.callback && this.callback(this.data);
        } else {
          this.callback && this.callback(this.param);
        }

        this.showDialog = false;
      }
    },
    cancel() {
      this.showDialog = false;
      this.cancelCall && this.cancelCall();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/common/verify/index.vue